import React from 'react'
import ImageViewer from '../ImageViewer/index'


export default function Header({
  names,
  username,
  imageUrl,
  left = false
}) {
  return (
    <div className="">
      <div className={"flex flex-row gap-2 items-center " + (left && " flex-row-reverse ")}>
        <div className="border rounded bg-red-400 py-1 px-1">
          <ImageViewer
            imageUrl={imageUrl}
            width={40}
            height={40}
            imageType="profile-game"
          />
        </div>
        <p className={"flex flex-col items-left mt-2 " + (left && " text-right ")} >
          <span className="font-bold">{names}</span>
          <span className="text-muted text-xs">{username}</span>
        </p>
      </div>
    </div>
  )
}
